import { lazy, Suspense, useEffect } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { getRuntimeConfig } from '@shared/config/runtime';












import {
  APPLICATION_ROOT_PATH,
  DIT_TRUST_PROOFS_PATH,
  PARTNER_INBOX_PATH,
  getApplicationStepPath,
} from './applicationFlow';

const ChallengeGrantLanding = lazy(() => import('@/pages/ChallengeGrantLanding').then((module) => ({ default: module.ChallengeGrantLanding })));
const Dashboard = lazy(() => import('@/pages/Dashboard').then((module) => ({ default: module.Dashboard })));
const GrantProofEligibility = lazy(() => import('@/pages/GrantProofEligibility').then((module) => ({ default: module.GrantProofEligibility })));
const KommuneSigningPopup = lazy(() => import('@/pages/KommuneSigningPopup').then((module) => ({ default: module.KommuneSigningPopup })));
const PartnerInbox = lazy(() => import('@/pages/PartnerInbox').then((module) => ({ default: module.PartnerInbox })));
const PersonalWalletPopup = lazy(() => import('@/pages/PersonalWalletPopup').then((module) => ({ default: module.PersonalWalletPopup })));
const SigningPopup = lazy(() => import('@/pages/SigningPopup').then((module) => ({ default: module.SigningPopup })));
const Step1OmProsjektet = lazy(() => import('@/pages/Step1OmProsjektet').then((module) => ({ default: module.Step1OmProsjektet })));
const Step2StotteVedlegg = lazy(() => import('@/pages/Step2StotteVedlegg').then((module) => ({ default: module.Step2StotteVedlegg })));
const Step3Samarbeidspartner = lazy(() => import('@/pages/Step3Samarbeidspartner').then((module) => ({ default: module.Step3Samarbeidspartner })));
const Step4Oppsummering = lazy(() => import('@/pages/Step4Oppsummering').then((module) => ({ default: module.Step4Oppsummering })));
const WalletPopup = lazy(() => import('@/pages/WalletPopup').then((module) => ({ default: module.WalletPopup })));

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export function AppRoutes() {
  const isCircularFastTrack = getRuntimeConfig().app.variant === 'oslo-circular-fast-track';

  return (
    <>
      <ScrollToTop />
      <Suspense fallback={<div role="status" aria-label="Loading" className="p-8">…</div>}>
      <Routes>
        <Route
          path="/"
          element={isCircularFastTrack ? <ChallengeGrantLanding /> : <Navigate to={APPLICATION_ROOT_PATH} replace />}
        />
        <Route
          path={DIT_TRUST_PROOFS_PATH}
          element={isCircularFastTrack ? <GrantProofEligibility /> : <Navigate to={APPLICATION_ROOT_PATH} replace />}
        />
        <Route path={APPLICATION_ROOT_PATH} element={<Step1OmProsjektet />} />
        <Route path={PARTNER_INBOX_PATH} element={<PartnerInbox />} />
        <Route path={getApplicationStepPath(2)} element={<Step2StotteVedlegg />} />
        <Route path={getApplicationStepPath(3)} element={<Step3Samarbeidspartner />} />
        <Route path={getApplicationStepPath(4)} element={<Step4Oppsummering />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/wallet-popup" element={<WalletPopup />} />
        <Route path="/personal-wallet-popup" element={<PersonalWalletPopup />} />
        <Route path="/signing-popup" element={<SigningPopup />} />
        <Route path="/kommune-signing-popup" element={<KommuneSigningPopup />} />
        <Route path="*" element={<Navigate to={isCircularFastTrack ? '/' : APPLICATION_ROOT_PATH} replace />} />
      </Routes>
      </Suspense>
    </>
  );
}
